import { render, staticRenderFns } from "./DailyTasksKiko.vue?vue&type=template&id=195b2746&scoped=true"
import script from "./DailyTasksKiko.vue?vue&type=script&lang=js"
export * from "./DailyTasksKiko.vue?vue&type=script&lang=js"
import style0 from "./DailyTasksKiko.vue?vue&type=style&index=0&id=195b2746&prod&lang=less&scoped=true"
import style1 from "./DailyTasksKiko.vue?vue&type=style&index=1&id=195b2746&prod&lang=less&scoped=true"
import style2 from "./DailyTasksKiko.vue?vue&type=style&index=2&id=195b2746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b2746",
  null
  
)

export default component.exports